<template>
  <div class="menuBody">
    <img :src="menu" class="menu-icon" @click="toggle" />
    <Drawer @close="toggle" align="right" :closeable="true">
      <div class="menuWrapper" v-if="open">
        <div class="menuContent" v-if="open">
          <!-- <p @click="home">REQUEST CAR</p> -->
          <p @click="home">{{ this.$store.getters.TRANSLATIONS["home"] }}</p>
          <p @click="history">
            {{ this.$store.getters.TRANSLATIONS["history"] }}
          </p>
          <p @click="profile">
            {{ this.$store.getters.TRANSLATIONS["profile"] }}
          </p>
          <p @click="marketing">
            {{ this.$store.getters.TRANSLATIONS["vouchers"] }}
          </p>
          <p @click="loyalty">
            {{ this.$store.getters.TRANSLATIONS["loyalty_program"] }}
          </p>
          <p @click="payments">
            {{ this.$store.getters.TRANSLATIONS["payments"] }}
          </p>
          <p @click="cars">
            {{ this.$store.getters.TRANSLATIONS["virtual_garage"] }}
          </p>
          <p
            v-if="this.$store.getters.RESIDENTS.length > 0"
            @click="residential"
          >
            {{ this.$store.getters.TRANSLATIONS["residential"] }}
          </p>
          <div class="menuFooter">
            <img :src="supportImage" class="supportImage" />
            <p>
              <a href="mailto:support@parkenda.com">{{
                this.$store.getters.TRANSLATIONS["support"]
              }}</a>
            </p>
            <p @click="signOut">
              {{ this.$store.getters.TRANSLATIONS["signout"] }}
            </p>
          </div>
        </div>
        <div class="menuVersion"></div>

        <p class="version">Version: {{ config.version }}</p>
      </div>
    </Drawer>
  </div>
</template>

<script>
import Drawer from "vue-simple-drawer";

export default {
  data() {
    return {
      menu: require("@/assets/menu.png"),
      supportImage: require("@/assets/new_design/Parkenda_Brandmark_Black.png"),
      open: false,
      signOut: () => {
        this.$storage.remove("parkendaToken");
        this.$store.dispatch("LOG_OUT");
        this.$store.dispatch("SET_LANGUAGE", "en");
        this.$store.dispatch(
          "SET_TRANSLATIONS",
          require(`../assets/i18n/en.json`)
        );
        this.$router.push("/login");
      },
      profile: () => {
        if (this.$route.name !== "Profile") {
          this.$router.push("/profile");
        }
        this.toggle();
      },
      history: () => {
        if (this.$route.name !== "HistoryVehicles") {
          this.$router.push("/historyVehicles");
        }
        this.toggle();
      },
      payments: () => {
        if (this.$route.name !== "CardsList") {
          this.$router.push("/cardsListSquare");
        }
        this.toggle();
      },
      loyalty: () => {
        if (this.$route.name !== "LoyaltyList") {
          this.$router.push("/loyaltyList");
        }
        this.toggle();
      },
      marketing: () => {
        if (this.$route.name !== "MarketCampagnsList") {
          this.$router.push("/marketCampagnsList");
        }
        this.toggle();
      },
      cars: () => {
        if (this.$route.name !== "CarsList") {
          this.$router.push("/carsList");
        }
        this.toggle();
      },
      residential: () => {
        // <---

        if (
          this.$store.getters.RESIDENTS.every(
            (resident) =>
              resident.locationId ===
              this.$store.getters.RESIDENTS[0].locationId
          )
        ) {
          console.log("found one location");

          this.$store.dispatch(
            "SET_RESIDENTS_TAGS",
            this.$store.getters.RESIDENTS[0].tags
          );

          if (this.$store.getters.RESIDENTS[0].tags.length === 1) {
            this.$store.dispatch(
              "SET_SELECTED_RESIDENT_TAG",
              this.$store.getters.RESIDENTS[0].tags[0]
            );
            if (this.$route.name !== "TagDetails") {
              this.$router.push("/tagDetails");
            }
          } else {
            if (this.$route.name !== "SelectTag") {
              this.$router.push("/selectTag");
            }
          }
        } else {
          console.log("found more than one location");
          if (this.$route.name !== "SelectLocation") {
            this.$router.push("/selectLocation");
          }
        }

        this.toggle();
      },
      home: () => {
        if (this.$store.getters.USER_HAVE_ACTIVE_PARKING) {
          if (this.$route.name !== "CurrentParking") {
            this.$router.push("/currentParking");
          }
        } else {
          if (this.$route.name !== "ParkendaValet") {
            this.$router.push("/parkendaValet");
          }
        }
        this.toggle();
      }
    };
  },
  components: {
    Drawer
  },
  methods: {
    toggle() {
      this.open = !this.open;
    }
  }
};
</script>

<style scoped src="../styles/main.css"></style>
<style scoped>
.menu-icon {
  height: 7vw;
}
.menuWrapper {
  padding: 75px 38px;
  margin: -40px -20px;
  height: 100vh;
  background: #72aeff;
}
.menuContent {
  display: flex;
  flex-direction: column;
  height: 85%;
}
.menuContent p {
  padding-bottom: 2vh;
}
.menuFooter {
  margin-top: auto;
}
a,
a:hover,
a:focus,
a:active {
  text-decoration: none;
  color: inherit;
}
/* .menu {
  font-size: 4vw;
}
.menu-icon {
  height: 7vw;
}
.menuWrapper {
  display: flex;
  flex-direction: column;
  height: 90vh;
  height: calc(var(--vh, 1vh) * 90);
}
.menuWrapper p {
  padding: 2.5vh;
}
.menuContent {
  background-color: #af7c00;
  flex: 1 0 auto;
  margin: 10px -20px;
  font-size: 1em;
  letter-spacing: 4px;
  font-weight: 100;
}
.menuFooter {
  background-color: #af7c00;
  flex: 0 0 auto;
  font-size: 0.9em;
  letter-spacing: 4px;
  font-weight: 100;
  margin: 0 -20px;
}
.version {
  background-color: #af7c00;
  font-size: 0.75em;
  letter-spacing: 4px;
  font-weight: 100;
  margin: 10px -20px 0;
}
a,
a:hover,
a:focus,
a:active {
  text-decoration: none;
  color: inherit;
} */
</style>



// WEBPACK FOOTER //
// src/components/ParkendaMenu.vue